import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_api_live } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

const initialData = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "" ,
  proremove : ""
};

const initialDataedu = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "",
  proremove : ""
};

let UserPlan = () => {
  let [data, setData] = useState();

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState(true);

  let [five, setFive] = useState();
  let [six, setSix] = useState();
  let [seven, setSeven] = useState(true);

  let [eight, setEight] = useState();
  let [nine, setNine] = useState();
  let [ten, setTen] = useState(true);


  let [four, setFour] = useState();

  let [utilityflow, setUtilityflow] = useState(true);

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  let [text, setText] = useState("");

  let [eduval, setEduval] = useState()
  let [utival, setUti] = useState()
  let [finedata, setFinedata] = useState()

  const [formBlocks, setFormBlocks] = useState([initialData]);

  const handleChange = (index, key, value) => {
    const updated = [...formBlocks];
    updated[index][key] = value;
    setFormBlocks(updated);
  };

  const addNewBlock = () => {
    setFormBlocks([...formBlocks, { ...initialData }]);
  };

  const removeBlock = (index) => {
    const updated = [...formBlocks];
    updated.splice(index, 1);
    setFormBlocks(updated);
  };
 
  const [formBlocksedu, setFormBlocksedu] = useState([initialDataedu]);

  const handleChangeedu = (index, key, value) => {
    const updated = [...formBlocksedu];
    updated[index][key] = value;
    setFormBlocksedu(updated);
  };

  const addNewBlockedu = () => {
    setFormBlocksedu([...formBlocksedu, { ...initialDataedu }]);
  };

  const removeBlockedu = (index) => {
    const updated = [...formBlocksedu];
    updated.splice(index, 1);
    setFormBlocksedu(updated);
  };


  function validateFields(dataArray) {
    const requiredFields = ['pro', 'proThree', 'profive', 'prouser'];
    const missingFields = [];
    
    dataArray.forEach((item, index) => {
        requiredFields.forEach(field => {
            // Check if field is missing, empty string, or null/undefined
            if (!item[field] || item[field].toString().trim() === '') {
                missingFields.push(`Item ${index + 1}: ${field} is missing or empty`);
            }
        });
    });
    
    if (missingFields.length > 0) {
        const alertMessage = "Missing or empty fields:\n" + missingFields.join('\n');
        alert(alertMessage);
        return false;
    }
    
    return true;
  }



  const saveJSON = async () => { 
    console.log( JSON.stringify( formBlocks ) , 'formBlocks');


    const isValid = validateFields(formBlocks);

    if (isValid) {
        console.log("All required fields have values!");
      } else {
          console.log("Validation failed - check the alert for details");
          alert('Enter data in all fields');
          return
      } 
 

    let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/userplan",
      data: {
        data: formBlocks
      }
    })
      .then((dat) => {
        newww()
        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success') 
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });
  };


  const saveJSONedu = async () => {
    console.log(formBlocksedu, 'formBlocks');

    const isValid = validateFields(formBlocksedu);

    if (isValid) {
        console.log("All required fields have values!");
      } else {
          console.log("Validation failed - check the alert for details");
          alert('Enter data in all fields');
          return
      } 
 

    let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/userplanedu",
      data: {
        data: formBlocksedu
      }
    })
      .then((dat) => {
        newww()
        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success') 
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });
  };

  useEffect(() => {
    Start();
    newww()
  }, []);

let newww = async () => {
  let apicall = await axios({
    method: "get",
    url: Base_url_api_live + "admin2/userplanget",
  })
    .then((dat) => {
      const uti = Array.isArray(dat.data.uti) ? dat.data.uti : [];
      const edu = Array.isArray(dat.data.edu) ? dat.data.edu : [];

      setFormBlocks(uti.length ? uti : [initialData]);
      setFormBlocksedu(edu.length ? edu : [initialDataedu]);

      console.log(dat.data, "userplanget response");
    })
    .catch((ee) => {
      console.log(ee, "userplanget error");
      // keep previous state as a safe array instead of leaving it broken
      setFormBlocks((prev) => (Array.isArray(prev) ? prev : [initialData]));
      setFormBlocksedu((prev) => (Array.isArray(prev) ? prev : [initialDataedu]));
    });
};

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let chsngeuttty = async (val, cmd) => {
    // console.log(val, "ggggggggggggg");
    // setUtilityflow(val);

    let token = await localStorage.getItem("token");

    let pp = { token, page: 1, limit: 10, utility: val };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url + "/admin2/flowwise",
      data: pp,
    })
      .then((dat) => {
        console.log(
          dat.data.data,
          "Jsson dddddddddddddddddddddddddddddddddddddddddd "
        );

        if (dat.data.status === true) {
        } else {
        }
      })
      .catch((ee) => { });
  };

  let chsngeutttys = async (val, cmd, gateway) => {
    // console.log(val, "ggggggggggggg");
    // setUtilityflow(val);

    let token = await localStorage.getItem("token");

    let pp = { token, page: 1, limit: 10, utility: val, cmd, gateway };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url + "/admin2/flowwise",
      data: pp,
    })
      .then((dat) => {
        console.log(
          dat.data.data,
          "Jsson dddddddddddddddddddddddddddddddddddddddddd "
        );

        if (dat.data.status === true) {
        } else {
        }
      })
      .catch((ee) => { });
  };

  let Submitt = async (edy) => {
    console.log(eduval, 'eduvaleduval')


    if (edy === 'edu') {
      let token = await localStorage.getItem("token");

      let pp = { token, val: edy, num: Number(eduval) };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "gst/changeedu",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          ); 
          if (dat.data.status === true) {
          } else {
          }
        })
        .catch((ee) => { });
    } else {
      let token = await localStorage.getItem("token");

      let pp = { token, val: 'uti', num: Number(utival) };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "gst/changeedu",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          ); 
          if (dat.data.status === true) {
          } else {
          }
        })
        .catch((ee) => { });
    }





  }

  let sendParNoti = async (block) => {

    console.log(block, 'blockblockblockblockblockblockblockblockblockblockblockblockblockblockblockblock')


    if( block.prouser === '' || block.prouser === undefined || block.prouser === null ){
      alert('Please enter User Phone No')
      return
    }

    if ( block.prohead === '' || block.prohead === undefined || block.prohead === null ){
      alert('Please enter Notification Header')
      return
    }

    if ( block.pronoti === '' || block.pronoti === undefined || block.pronoti === null ){
      alert('Please enter Notification Body')
      return
    }
 

    let apicall = await axios({
      method: "post",
      url: Base_url + "admin2/userplannoti",
      data: { notidata : block.prouser , prohead : block.prohead , pronoti : block.pronoti  }
    })
      .then((dat) => { 
        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success') 
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      }); 
  }

  let Remove = async (block) => {

    console.log(block, 'blockblockblockblockblockblockblockblockblockblockblockblockblockblockblockblockblock')
 
      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "admin2/removeuti",
        data: {  block  }
      })
        .then((dat) => { 
          // setFinedata(dat.data.data)
          newww()
          console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

          alert('Update Success') 
        })
        .catch((ee) => {
          console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
        }); 
  }

  let Removeedu = async (block) => {


    console.log(block, 'blockblockblockblockblockblockblockblockblockblockblockblockblockblockblockblock')
 
 



    let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/removeedu",
      data: {  block  }
    })
      .then((dat) => { 
        // setFinedata(dat.data.data)
        newww()
        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success') 
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      }); 
  }


  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <p className="mt-2" style={{ fontWeight: "bold", fontSize: "20px" }}>User Plan Utility</p>


          <div style={{ padding: 20 }}>
            {formBlocks?.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChange(index, "pro", e.target.value)
                    }
                    value={block.pro}
                    style={{ width: "98%" }}
                  >
                    <option value="Sameday">Sameday</option>
                    <option value="T1">T1</option>
                    <option value="T2">T2</option>
                    <option value="T3">T3</option>
                    <option value="T4">T4</option>
                  </select>
                </div> 

                <div className="col-3">
                  <div className="row" >
                    
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChange(index, "profive", e.target.value)
                        }
                        value={block.profive}
                        placeholder="max"
                        style={{ width: "98%" }}
                      />

                    </div>

                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChange(index, "proThree", e.target.value)
                        }
                        value={block.proThree}
                        placeholder="presentage %"
                        style={{ width: "98%" }}
                      />


                     



                    </div>

                    


                  </div> 
                </div> 

                <div className="col-3">
                  <textarea
                    type="text"
                    onChange={(e) =>
                      handleChange(index, "prouser", e.target.value)
                    }
                    value={block.prouser}
                    placeholder="User Phone No : xxxxxx,xxxxxxx"
                    style={{ width: "98%" }}
                  />

                  <div className="d-flex" >
                    <textarea
                      type="text"
                      onChange={(e) =>
                        handleChange(index, "proremove", e.target.value)
                      }
                      value={block.proremove}
                      placeholder="Phone No"
                      style={{ width: "98%" ,  }}
                    />

                    <div >
                      <button onClick={() => { Remove(block) }} >Remove</button>
                    </div >
                  </div>

                  
                </div>

                <div className="col-2">
                  <input
                    type="text"
                    onChange={(e) =>
                      handleChange(index, "prohead", e.target.value)
                    }
                    value={block.prohead}
                    placeholder="Notification Header"
                    style={{ width: "100%" , marginBottom : 5  }}
                  />

                  <textarea
                    type="text"
                    onChange={(e) =>
                      handleChange(index, "pronoti", e.target.value)
                    }
                    value={block.pronoti}
                    placeholder="Notification"
                    style={{ width: "100%" }}
                  />
                </div>



                <div className="col-1">
                  <div className="d-flex justify-content-between gap-2">
                    <button onClick={() =>{

                      sendParNoti(block)

                     }}>Send Notification</button>
                    <button onClick={() => removeBlock(index)}>❌</button>
                  </div>
                  
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlock} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSON}>💾 Save</button>
            </div>
          </div>

          <p className="mt-2" style={{ fontWeight: "bold", fontSize: "20px" }}>User Plan Education</p>

          <div style={{ padding: 20 }}>
            {formBlocksedu.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangeedu(index, "pro", e.target.value)
                    }
                    value={block.pro}
                    style={{ width: "98%" }}
                  >
                    <option value="Sameday">Sameday</option>
                    <option value="T1">T1</option>
                    <option value="T2">T2</option>
                    <option value="T3">T3</option>
                    <option value="T4">T4</option>
                  </select>
                </div>

                 <div className="col-3">
                  <div className="row" >
                    
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangeedu(index, "profive", e.target.value)
                        }
                        value={block.profive}
                        placeholder="max"
                        style={{ width: "98%" }}
                      />

                    </div>

                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangeedu(index, "proThree", e.target.value)
                        }
                        value={block.proThree}
                        placeholder="presentage %"
                        style={{ width: "98%" }}
                      />
                    </div>

                    


                  </div> 
                </div> 

                <div className="col-3">
                  <textarea
                    type="text"
                    onChange={(e) =>
                      handleChangeedu(index, "prouser", e.target.value)
                    }
                    value={block.prouser}
                    placeholder="User Phone No : xxxxxx,xxxxxxx"
                    style={{ width: "98%" }}
                  />

                   <div className="d-flex" >
                    <textarea
                      type="text"
                      onChange={(e) =>
                        handleChangeedu(index, "proremove", e.target.value)
                      }
                      value={block.proremove}
                      placeholder="Phone No"
                      style={{ width: "98%" ,  }}
                    />

                    <div >
                      <button onClick={() => { Removeedu(block) }} >Remove</button>
                    </div >
                  </div>


                </div>

                <div className="col-2">

                  <input
                    type="text"
                    onChange={(e) =>
                      handleChangeedu(index, "prohead", e.target.value)
                    }
                    value={block.prohead}
                    placeholder="Notification Header"
                    style={{ width: "100%" , marginBottom : 5  }}
                  />


                  <textarea
                    type="text"
                    onChange={(e) =>
                      handleChangeedu(index, "pronoti", e.target.value)
                    }
                    value={block.pronoti}
                    placeholder="Notification"
                    style={{ width: "100%" }}
                  />
                </div>



                <div className="col-1">
                  <div className="d-flex justify-content-between gap-2">
                    <button onClick={() =>{

                      sendParNoti(block)

                     }}>Send Notification</button>
                    <button onClick={() => removeBlockedu(index)}>❌</button>
                  </div>
                  
                </div> 
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlockedu} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSONedu}>💾 Save</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserPlan;
